var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "5.75 1.75 20.5 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.97 1.75H7.03c-.71 0-1.28.57-1.28 1.28v25.94c0 .7.57 1.28 1.28 1.28h17.94c.71 0 1.28-.58 1.28-1.28V3.03c0-.71-.57-1.28-1.28-1.28zm-3.13 17.38c-.81.8-1.87 1.24-3 1.24-.68 0-1.33-.16-1.92-.45l.81 4.33c.02.03.03.07.03.12 0 .13-.11.25-.25.25H14.5c-.07 0-.15-.04-.19-.1a.242.242 0 0 1-.06-.2l.83-4.4c-.59.29-1.24.45-1.92.45-1.13 0-2.19-.44-3-1.24-.8-.8-1.24-1.87-1.24-3.01 0-1.13.44-2.2 1.24-3l5.66-5.66c.1-.1.26-.1.36 0l5.66 5.66c1.65 1.65 1.65 4.35 0 6.01z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.1ce142b9145919b62aed28dfdfffaf98.svg";
export { ForwardRef as ReactComponent };